import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate, useParams } from "react-router-dom";
import { getFaqDetails, editFaq } from "../../api/apiHandler";
import { showMessage, showErrorMessage } from "../common/Utils";
import $ from 'jquery';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';

export function Editfaq() {

    let { faq_id } = useParams(); faq_id = atob(faq_id);

    const selectRef = useRef();
    let editFormRef = useRef(null);
    let navigate = useNavigate();

    const [ faqData, setFaqData ] = useState({
        faq_id: '',
        question: '',
        answer: '',
        status: ''
    });
    useEffect(() => {

        // Initialize Select2 on the select element
        $(selectRef.current).select2();

        // Initialize the parsley plugin
        $(editFormRef.current).parsley();

        async function getFaqsData() {
            const faqReq = {
                faq_id: faq_id
            }
            const response = await getFaqDetails(faqReq);
            if (parseInt(response.code) === 1) {
                setFaqData(response.data);
                return response.data;
            } else {
                showErrorMessage(response.message);
                return null;
            }
        }
        getFaqsData();
        // Set the initial selected value
        $(selectRef.current).val(faqData.status).trigger('change');
    }, []);

    useEffect(() => {
        if (faqData) {
          // Set the initial selected value after the data is loaded
          $(selectRef.current).val(faqData.status).trigger('change');
        }
    }, [faqData]);

    const handleAddRequest = async(e) => {
        e.preventDefault();
        
        if ($(editFormRef.current).parsley().isValid()) {

            const editfaqdata = {
                faq_id: faq_id,
                question: editFormRef.current.question.value,
                answer: editFormRef.current.answer.value,
                status: editFormRef.current.faqstatus.value,
            };

            const response = await editFaq(editfaqdata);
            if (parseInt(response.code) === 1) {
                showMessage(response.message);
                navigate('/faqs/listing');
            } else {
                showErrorMessage(response.message);
            }
        } else {
            showErrorMessage("Something went wrong, some required fields are missing!");
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };
    
    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Edit FAQs</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/faqs/listing">
                                        FAQs Listing
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Edit FAQs</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="col-md-8 col-lg-8 col-xl-8 offset-md-2">
                                        <form name="editFaq" id="editFaq" ref={editFormRef} onSubmit={handleAddRequest}>
                                            <div className="row">
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <textarea
                                                                style={{ height: '100px' }}
                                                                className="form-control"
                                                                name="question"
                                                                id="question"
                                                                data-parsley-trigger="change"
                                                                data-parsley-required-message="Please enter question"
                                                                data-parsley-required="true"
                                                                defaultValue={faqData.question}
                                                            ></textarea>
                                                            <label className="form-label">
                                                                Question <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <textarea
                                                                style={{ height: '100px' }}
                                                                className="form-control"
                                                                name="answer"
                                                                id="answer"
                                                                data-parsley-trigger="change"
                                                                data-parsley-required-message="Please enter answer"
                                                                data-parsley-required="true"
                                                                defaultValue={faqData.answer}
                                                            ></textarea>
                                                            <label className="form-label">
                                                                Answer <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group">
                                                        <label className="mb-3">Status</label>
                                                        <select ref={selectRef}
                                                            defaultValue='0'
                                                            className="form-control"
                                                            id="faqstatus"
                                                            name="faqstatus"
                                                            data-parsley-required="true"
                                                            data-parsley-required-message="Please select status"
                                                        >
                                                            <option value="">Choose One</option>
                                                            <option value={0}>Active</option>
                                                            <option value={1}>Inactive</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />
                                                <div className="col-md-4 col-lg-4 col-xl-4 offset-md-4">
                                                    <div className="form-group">
                                                        <button type="submit" className="btn btn-raised btn-primary waves-effect m-t-20 mr-3">
                                                            Submit
                                                        </button>
                                                        <a
                                                            href="#"
                                                            onClick={handleGoBack}
                                                            className="btn btn-raised btn-default waves-effect m-t-20"
                                                        >
                                                            Cancel
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}